import * as GQL from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { BreadcrumbType, getBreadcrumbsForHome } from ".";
import * as Url from "../url";

export const getBreadcrumbsForList = (
  organization: RD.RemoteData<unknown, GQL.Organization>
): BreadcrumbType[] => {
  return [
    ...getBreadcrumbsForHome(organization),
    {
      label: "Payments",
      href: organization
        .map((org) => Url.OrgAdmin.Payments.index(org))
        .withDefault("#"),
    },
  ];
};

export const getBreadcrumbsForActivity = (
  organization: RD.RemoteData<unknown, GQL.Organization>
): BreadcrumbType[] => {
  return [
    ...getBreadcrumbsForHome(organization),
    {
      label: "Payments",
      href: organization
        .map((org) => Url.OrgAdmin.Payments.index(org))
        .withDefault("#"),
    },
    {
      label: "Payments activity",
      href: organization
        .map((org) => Url.OrgAdmin.Payments.activity(org))
        .withDefault("#"),
    },
  ];
};
